import { clearableDateSchema } from '@bos/form';
import { z } from 'zod';

import { VerificationStateTypeV1 } from '../../../../../../api/generated/cz.partners.pid.backofficegateway.pididentityverification';

export const getIdentityVerificationFilterFormSchema = () =>
	z.object({
		verificationState: z.enum(VerificationStateTypeV1).optional(),
		completedAtFrom: clearableDateSchema(z.coerce.date()),
		completedAtTo: clearableDateSchema(z.coerce.date()),
		pidUuid: z.string().nullable().optional(),
	});

export type IdentityVerificationFilterForm = z.infer<
	ReturnType<typeof getIdentityVerificationFilterFormSchema>
>;
